import { combineReducers } from "redux";
import {authReducer} from "./reducers/auth/authReducer";
import {dashboardReducer} from "./reducers/dashboard/dashboard";
import subcategoryReducer from "./common/subcat";
import {productListingReducer} from "./common/product-listing";
import {productDetailReducer} from "./common/product-detail";
import cartReducer from "./common/cart-list";
import wishlistReducer from "./common/wishlist";
import orderReducer from "./common/orders";
import profileReducer from "./common/profile";
import searchReducer from "./reducers/search/search";





// Create the root reducer
const rootReducer = combineReducers({
    auth: authReducer,
    dashboard: dashboardReducer,
    subCategories: subcategoryReducer,
    productListing: productListingReducer,
    productDetail: productDetailReducer,
    cart: cartReducer,
    wishlist: wishlistReducer,
    orders: orderReducer,
    profile: profileReducer,
    search: searchReducer,
});

export default rootReducer;